import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopRightCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowTopRightCorner"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11 9H13.5859L9.58594 13L11 14.4141L15 10.4141V13H17V7H11V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowTopRightCorner;
